module.exports = __webpack_public_path__ + "img/1511208618.b3b4d8fc.jpg";